import React, { ReactNode } from 'react';
import { ElectronicIdLogo } from './logo';
import { ElectronicIdCountries } from './countries';
import { ElectronicIdToggle } from './toggle';
import style from './electronic-id.module.scss';

export type Props = {
  isChecked: boolean;
  isEnabled: boolean;
  isVisible: boolean;
  canUpdate: boolean;
  onEidToggle: () => void;
  title: ReactNode;
  description: ReactNode;
  itemKey: string;
  countries: string[];
  currentLanguage: string;
};

export const ElectronicId: React.FC<Props> = ({
  isChecked,
  isEnabled,
  isVisible,
  canUpdate,
  onEidToggle,
  title,
  description,
  itemKey,
  countries,
  currentLanguage,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={style.SectionContainer}>
      <div className={style.InnerContainer}>
        <div className={style.LogoContainer}><ElectronicIdLogo logoKey={itemKey} /></div>

        <div className={style.ContentContainer}>
          <div className={style.Title}>{title}</div>
          <div className={style.SubTitle}>
            <ElectronicIdCountries countries={countries} lang={currentLanguage} />
          </div>
        </div>

        <div className={style.ToggleContainer}>
          <div className={style.ToggleWrapper}>
            <ElectronicIdToggle
              isChecked={isChecked}
              isEnabled={isEnabled}
              canUpdate={canUpdate}
              onEidToggle={onEidToggle}
            />
          </div>
          <span className={style.ToggleInfo}>{description}</span>
        </div>
      </div>
    </div>
  );
};
